/**
 * The reserved "Unassigned" metro, seeded by migration with an all-zeros id.
 * organization-service returns it in `items` like any other row;
 * `toSalesMetros` drops it.
 */
export const UNASSIGNED_SALES_METRO_ID = '000000000000000000000000';
